/*
  Gate di consenso funzionale per la guida taglie KiwiSizing (issue #170,
  T195 punto 6). Carica lo script del plugin SOLO quando l'API Customer
  Privacy di Shopify (window.Shopify.customerPrivacy) dice che il trattamento
  "preferences" è consentito: consenso funzionale dato, oppure visitatore in
  una regione dove il banner non è richiesto (preferencesProcessingAllowed()
  copre entrambi i casi). Se la decisione è in sospeso (shouldShowBanner()
  true) si resta in attesa dell'evento visitorConsentCollected e si carica al
  momento dell'accettazione, senza ricaricare la pagina. Se l'API non è
  disponibile o dà errore: FAIL-OPEN, la guida taglie si carica comunque
  (stesso principio del gate mappa della PR #135). Nessuna dipendenza dagli
  ID di categoria OneTrust: il mapping del tenant resta libero.
*/
(function () {
  'use strict';

  var gateScript = document.currentScript || document.querySelector('script[data-kiwi-sizing-src]');
  var pluginSrc = gateScript && gateScript.getAttribute('data-kiwi-sizing-src');
  if (!pluginSrc) return;

  var loaded = false;

  function loadKiwiSizing() {
    if (loaded) return;
    loaded = true;
    var el = document.createElement('script');
    el.async = true;
    el.src = pluginSrc;
    document.head.appendChild(el);
  }

  // Ricarica al cambio di consenso: se il visitatore accetta i funzionali
  // dal banner, la guida taglie compare senza bisogno di ricaricare la pagina.
  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = event && event.detail;
    if (detail && detail.preferencesAllowed) loadKiwiSizing();
  });

  function evaluate(api) {
    try {
      if (api.preferencesProcessingAllowed()) {
        // Consenso funzionale presente, oppure regione senza obbligo di
        // banner: nei due casi la documentazione Shopify garantisce true.
        loadKiwiSizing();
      }
      // Altrimenti: rifiuto esplicito → niente guida taglie; decisione in
      // sospeso (shouldShowBanner() true) → si attende visitorConsentCollected.
    } catch (e) {
      loadKiwiSizing(); // fail-open
    }
  }

  var api = window.Shopify && window.Shopify.customerPrivacy;
  if (api && typeof api.preferencesProcessingAllowed === 'function') {
    evaluate(api);
  } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        var loadedApi = window.Shopify && window.Shopify.customerPrivacy;
        if (error || !loadedApi || typeof loadedApi.preferencesProcessingAllowed !== 'function') {
          loadKiwiSizing(); // fail-open: API non disponibile
        } else {
          evaluate(loadedApi);
        }
      }
    );
  } else {
    loadKiwiSizing(); // fail-open: ambiente senza Shopify.loadFeatures
  }
})();
